import {
  BULK_UPLOAD_START,
  BULK_UPLOAD_SUCCESS,
  BULK_UPLOAD_FAIL,
  BULK_SUMMARY_GET,
  BULK_SUMMARY_SUCCESS,
  BULK_SUMMARY_FAIL,
  BULK_TASK_STATUS_UPDATE,
  BULK_TASKS_LIST_GET,
  BULK_TASKS_LIST_SUCCESS,
  BULK_TASKS_LIST_FAIL,
  BULK_RESET,
} from "./actionTypes";

export const bulkUploadStart = (formData, params) => ({
  type: BULK_UPLOAD_START,
  payload: { formData, params },
});

export const bulkUploadSuccess = (data) => ({
  type: BULK_UPLOAD_SUCCESS,
  payload: data,
});

export const bulkUploadFail = (error) => ({
  type: BULK_UPLOAD_FAIL,
  payload: error,
});

export const bulkSummaryGet = (taskId, format) => ({
  type: BULK_SUMMARY_GET,
  payload: { taskId, format },
});

export const bulkSummarySuccess = (data) => ({
  type: BULK_SUMMARY_SUCCESS,
  payload: data,
});

export const bulkSummaryFail = (error) => ({
  type: BULK_SUMMARY_FAIL,
  payload: error,
});

export const bulkTaskStatusUpdate = (status, validationErrors) => ({
  type: BULK_TASK_STATUS_UPDATE,
  payload: { status, validationErrors },
});

export const bulkTasksListGet = (params) => ({
  type: BULK_TASKS_LIST_GET,
  payload: params,
});

export const bulkTasksListSuccess = (data) => ({
  type: BULK_TASKS_LIST_SUCCESS,
  payload: data,
});

export const bulkTasksListFail = (error) => ({
  type: BULK_TASKS_LIST_FAIL,
  payload: error,
});

export const bulkReset = () => ({ type: BULK_RESET });
